var VehicleOnObjectTrackModal = (function (base) {
  __extends(VehicleOnObjectTrackModal, base);

  function VehicleOnObjectTrackModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

  VehicleOnObjectTrackModal.prototype.activate = function (htmlContent, trackName, tracksUrl, roadId, startKm, stopKm, showRuler) {
    const self = this;
    const $modal = ModalHelper.create().show().busy();
    self.$modal = $modal;

    htmlContent = htmlContent.replace('\${trackName}', trackName);

    $modal.content(htmlContent).busy(false);

    var containerHeight = $(window).height() * 0.65;
    $('#track-map', $modal).height(containerHeight);

    var tracks;
    var map;
    setTimeout(function () {
        map = initVehicleTrackMap(showRuler);
        if (roadId)
            initRoadSegmentOnMapShowing(map, roadId, startKm, stopKm);
        initTracksOnMapShowing(map, tracksUrl);
        if (showRuler)
            Ruler.init(map);
    }, 200);

    $modal
      .on('click', '[js=close],.close', () => {
        self.close({ cancel: true });
      })
      .on('keydown',
        e => {
          if (e.keyCode === 27) {
            self.close({ cancel: true });
            e.stopPropagation();
          }
        });
  };

  return VehicleOnObjectTrackModal;
}(BaseModal));
